import _ from 'underscore';
import $ from 'jquery';

export default class UserProductCopyFromUserDialog {
  constructor($scope, UserService, UserProductService, UiService) {
    $scope.copy_mode = 1;
    $scope.copy_modes = this.get_copy_modes();

    $scope.$on('show_user_products_copy_from_user_dialog', (event, data) => {
      this.target_user_id = data.user_id;

      UiService.open_fancybox_dialog('div#user_product_copy_from_user_dialog');
    });

    $scope.$watch('source_user_id', this.load_user_products.bind(this));
    $scope.submit = this.submit.bind(this);

    this.$scope = $scope;
    this.UserService = UserService;
    this.UserProductService = UserProductService;
    this.UiService = UiService;
    this.set_buyer_company_autocomplete($('input.buyer_company'));
  }

  get_copy_modes() {
    return [
      {id: 1, title: 'Copy Product Quality'},
      {id: 2, title: 'Copy Product Quality & Specs'},
      {id: 3, title: 'Copy Product Quality & Full Specs'}
    ];
  }

  set_buyer_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: (request, response) => {
        this.UserService.search_by_company('Buyer', request.term)
          .then((data) => {
            response(data.users);
          });
      },
      select: (event, ui) => {
        this.$scope.source_user_id = ui.item.id;
        this.$scope.$apply();
      }
    });
  }

  load_user_products(source_user_id) {
    this.$scope.user_products = [];

    if (!source_user_id) {
      return;
    }

    this.UserProductService.get_user_products_for_copy_from_user(source_user_id)
      .then((res) => {
        this.$scope.user_products = res.data.user_products;
      });
  }

  submit() {
    const user_products = _.pluck(
      _.where(this.$scope.user_products, {checked: true}
    ), 'id');

    if (user_products.length === 0) {
      alert('Please select at least one user product!');
      return;
    }

    this.$scope.submitting = true;

    this.UserProductService.copy_user_products_from_user(
      this.target_user_id,
      user_products,
      this.$scope.copy_mode
    )
    .then(() => {
      this.$scope.submitting = false;
      this.UiService.close_fancybox_dialog();
    });
  }
}

UserProductCopyFromUserDialog.$inject = ['$scope', 'UserService',
  'UserProductService', 'UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-copy-from-user-dialog.ctrl.js